<template>
  <section
      ref="section25"
      :class="[
          Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
          'mx-auto flex h-full flex-col',
      ]"
  >
      <v-add-listing-head :routes="routes" :step="28"></v-add-listing-head>
      <main
          class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
      >
          <figure class="flex w-full flex-col gap-11">
              <figure class="mx-auto flex w-full max-w-xl gap-3">
                  <div><v-icon icon="add-to-photos" size="8"></v-icon></div>
                  <div class="flex flex-col justify-center">
                      <div class="mb-3 text-heading-3-desktop">
                          Fotografije dodatne dokumentacije
                      </div>
                      <div class="text-body-regular text-black-40">
                          Naložite lahko JPG ali PNG tipa slik. Velikost ne
                          sme presegati 2 mb.
                      </div>
                  </div>
              </figure>
              <figure
                  class=""
              >
                <form
                  method="POST"
                  :action="routes.submitForm"
                  id="select-documentation-pictures"
                  enctype="multipart/form-data"
                  class="mx-auto flex w-full max-w-3xl flex-col gap-6 md:flex-row"

                >
                  <v-csrf-token></v-csrf-token>
                  <input class="hidden" type="number" name="tloris_pictures[]" :value="tlorisPicture.id" v-for="tlorisPicture in tlorisPictures" :key="tlorisPicture.name" />
                  <input class="hidden" type="number" name="energy_pictures[]" :value="energyPicture.id" v-for="energyPicture in energyPictures" :key="energyPicture.name" />

                  <v-lightbox
                      is-authenticated
                      :foot-class="'justify-between px-6'"
                      class="flex w-full flex-col items-center justify-center rounded-2xl bg-green-10 py-9 md:rounded-3xl md:py-11"
                      :show="showTlorisModal"
                      @close="showTlorisModal = false"
                  >
                      <template v-slot:trigger>
                        <figure @click="showTlorisModal = true" class="flex flex-col items-center">
                          <div
                              class="flex gap-2 text-icon-text-medium text-black-78"
                          >
                              <v-icon icon="arhitecture" size="4"></v-icon>
                              Tloris
                          </div>
                          <div class="mt-4">
                              <v-icon
                                  icon="arhitecture"
                                  class="text-green-49 max-sm:h-16 max-sm:w-16"
                              ></v-icon>
                          </div>
                          <div
                              class="my-4 text-body-regular text-black-40 md:my-6"
                          >
                              Naložili ste
                              <b class="text-black-78"
                                  >{{ tlorisPictures.length }}/20</b
                              >
                              datotek
                          </div>
                          <div>
                              <button class="button cursor-pointer" type="button">
                                  <v-icon icon="folder"></v-icon>
                                  <label>Izberite fotografije</label>
                              </button>
                          </div>
                        </figure>
                      </template>
                      <template v-slot:head>
                          <v-icon
                              icon="arhitecture"
                              size="4"
                              class="mr-2.5"
                          ></v-icon>
                          Tloris
                      </template>
                      <template v-slot:content>
                          <div class="text-body-regular text-black-40">
                              Naložite lahko PNG ali JPG datoteke. Največja
                              velikost datoteke je 2 MB.
                          </div>
                          <figure
                            class="flex flex-col"
                            :class="
                              {'flex-col-reverse' : tlorisPictures.length > 0,},
                              {'mt-4': tlorisPictures.length == 0,}"
                          >
                            <div class="tloris-dropzone">
                                <div
                                    class="dropzone-container flex w-full items-center justify-center rounded-3xl"
                                    :class="[(energyPictures.length == 0 ? 'h-[240px] bg-green-10 md:h-[21.5rem]' : ''),(tooLargeError ? 'border border-salmon-base': ''),(errors ? 'border border-salmon-base' : '')]"
                                    @dragover="dragoverTloris"
                                    @dragleave="dragleaveTloris"
                                    @drop="dropTlorisFile"
                                >
                                    <input
                                        type="file"
                                        multiple
                                        id="tlorisFilesInput"
                                        class="hidden"
                                        @change="
                                          onChangePictures(
                                              $event,
                                              'tloris_image'
                                          )
                                      "
                                      ref="tlorisFilesInput"
                                      accept=".jpg,.jpeg,.png,.pdf"
                                    />
                                    <label
                                      for="tlorisFilesInput"
                                      class="file-label"
                                  >
                                      <div v-if="isDraggingTloris" class="flex flex-col items-center justify-center text-body-regular text-black-78">
                                        Izpustite za začetek nalaganja
                                      </div>
                                      <div v-else class="flex flex-col items-center justify-center text-body-regular text-black-78">
                                        <template
                                              v-if="
                                                  tlorisPictures.length <
                                                  1
                                              "
                                          >
                                              <div>
                                                  <v-icon
                                                      icon="energy-program-time-used"
                                                      class="mb-6 text-green-49"
                                                  ></v-icon>
                                              </div>
                                              <div class="hidden lg:flex">
                                                  Povlecite datoteke sem za
                                                  nalaganje
                                              </div>
                                              <div
                                                  class="mb-6 mt-6 hidden text-small-text-regular text-black-40 lg:flex"
                                              >
                                                  ali
                                              </div>
                                              <div>
                                                  <button
                                                    type="button"
                                                    class="button button--large cursor-pointer"
                                                    @click="openTlorisFileInput()"
                                                  >
                                                      <v-icon
                                                          icon="folder"
                                                      ></v-icon>
                                                      <label
                                                          >Izberite
                                                          fotografije</label
                                                      >
                                                  </button>
                                              </div>
                                          </template>
                                          <template v-else>
                                              <div>
                                                  <button
                                                    type="button"
                                                    class="button button--large cursor-pointer"
                                                    @click="openTlorisFileInput()"
                                                  >
                                                      <v-icon
                                                          icon="folder"
                                                      ></v-icon>
                                                      <label
                                                          >Dodajte
                                                          fotografije</label
                                                      >
                                                  </button>
                                              </div>
                                          </template>
                                      </div>
                                    </label>
                                </div>
                                <figure
                                    class="mx-auto flex w-full max-w-lg gap-3"
                                    v-if="tooLargeError"
                                >
                                    <div class="text-small-regular text-salmon">
                                        Izbrana fotografija presega največjo dovoljeno velikost.
                                        Prosimo izberite drugo fotografijo.
                                    </div>
                                </figure>
                                <figure
                                    class="mx-auto flex w-full max-w-lg gap-3"
                                    v-if="errors"
                                >
                                    <div class="text-small-regular text-salmon">
                                        Prišlo je do napake pri nalaganju, preverite da je datoteka slika.
                                    </div>
                                </figure>
                            </div>
                            <div
                              class="pictures-preview-and-actions mb-4"
                              v-if="tlorisPictures.length"
                          >
                              <div
                                  v-for="tlorisPicture in tlorisPictures"
                                  :key="tlorisPicture.name"
                                  class="flex items-center justify-between border-b py-4"
                              >
                                <!-- <img
                                    class="preview-img"
                                    :src="
                                        tlorisPicture.listing_image_url
                                    "
                                /> -->
                                <div class="text-body-medium-button text-black-78 max-w-[45%] truncate md:max-w-full">
                                  {{ tlorisPicture.name }}
                                </div>
                                <button class="button button--gray" type="button"
                                  @click="removeFile(tlorisPictures.indexOf(tlorisPicture),'tloris_image')"
                                >
                                  <v-icon icon="delete"></v-icon>
                                  <label>Odstrani</label>
                                </button>
                              </div>
                            </div>
                        </figure>
                      </template>
                      <template v-slot:foot>
                        <a class="button button--gray" @click="removeFiles('tloris_image')">
                            <v-icon icon="reload"></v-icon>
                            <label>Ponastavi</label>
                        </a>
                        <a class="button" @click="showTlorisModal = false">
                            <v-icon icon="save"></v-icon>
                            <label>Shrani</label>
                        </a>
                      </template>
                  </v-lightbox>
                  <v-lightbox
                    is-authenticated
                      :foot-class="'justify-between px-6'"
                      class="flex w-full flex-col items-center justify-center rounded-2xl bg-green-10 py-9 md:rounded-3xl md:py-11"
                      :show="showEnergyModal"
                      @close="showEnergyModal = false"
                  >
                      <template v-slot:trigger>
                        <figure @click="showEnergyModal = true" class="flex flex-col items-center">
                          <div
                              class="flex gap-2 text-icon-text-medium text-black-78"
                          >
                              <v-icon
                                  icon="energy-program-time-used"
                                  size="4"
                              ></v-icon>
                              Energetska izkaznica
                          </div>
                          <div class="mt-4">
                              <v-icon
                                  icon="energy-program-time-used"
                                  class="text-green-49 max-sm:h-16 max-sm:w-16"
                              ></v-icon>
                          </div>
                          <div
                              class="my-4 text-body-regular text-black-40 md:my-6"
                          >
                              Naložili ste
                              <b class="text-black-78"
                                  >{{ energyPictures.length }}/20</b
                              >
                              datotek
                          </div>
                          <div>
                              <button class="button" type="button">
                                  <v-icon icon="folder"></v-icon>
                                  <label>Izberite fotografije</label>
                              </button>
                          </div>
                        </figure>
                      </template>
                      <template v-slot:head>
                          <v-icon
                              icon="energy-program-time-used"
                              size="4"
                              class="mr-2.5"
                          ></v-icon>
                          Energetska izkaznica
                      </template>
                      <template v-slot:content>
                          <div class="text-body-regular text-black-40">
                              Naložite lahko PNG ali JPG datoteke. Največja
                              velikost datoteke je 2 MB.
                          </div>
                          <figure
                            class="flex flex-col"
                            :class="
                              {'flex-col-reverse' : energyPictures.length > 0,},
                              {'mt-4': energyPictures.length == 0,}"
                          >
                            <div class="energy-dropzone">
                                <div
                                    class="dropzone-container flex w-full items-center justify-center rounded-3xl"
                                    :class="[(energyPictures.length == 0 ? 'h-[240px] bg-green-10 md:h-[21.5rem]' : ''),(tooLargeError ? 'border border-salmon-base': ''),(errors ? 'border border-salmon-base' : '')]"
                                    @dragover="dragoverEnergy"
                                    @dragleave="dragleaveEnergy"
                                    @drop="dropEnergyFile"
                                >
                                    <input
                                        type="file"
                                        multiple
                                        id="energyFilesInput"
                                        class="hidden"
                                        @change="
                                            onChangePictures(
                                                $event,
                                                'energy_image'
                                            )
                                        "
                                        ref="energyFilesInput"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                    />

                                    <label
                                        for="energyFilesInput"
                                        class="file-label"
                                    >
                                        <div
                                            v-if="isDraggingEnergy"
                                            class="flex flex-col items-center justify-center text-body-regular text-black-78"
                                        >
                                            Izpustite za začetek nalaganja
                                        </div>
                                        <div
                                            v-else
                                            class="flex flex-col items-center justify-center text-body-regular text-black-78"
                                        >
                                            <template
                                                v-if="
                                                    energyPictures.length <
                                                    1
                                                "
                                            >
                                                <div>
                                                    <v-icon
                                                        icon="energy-program-time-used"
                                                        class="mb-6 text-green-49"
                                                    ></v-icon>
                                                </div>
                                                <div class="hidden lg:flex">
                                                    Povlecite datoteke sem za
                                                    nalaganje
                                                </div>
                                                <div
                                                    class="mb-6 mt-6 hidden text-small-text-regular text-black-40 lg:flex"
                                                >
                                                    ali
                                                </div>
                                                <div>
                                                    <button
                                                        type="button"
                                                        class="button button--large cursor-pointer"
                                                        @click="openEnergyFileInput()"
                                                    >
                                                        <v-icon
                                                            icon="folder"
                                                        ></v-icon>
                                                        <label
                                                            >Izberite
                                                            fotografije</label
                                                        >
                                                    </button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <button
                                                        type="button"
                                                        class="button button--large cursor-pointer"
                                                        @click="openEnergyFileInput()"
                                                    >
                                                        <v-icon
                                                            icon="folder"
                                                        ></v-icon>
                                                        <label
                                                            >Dodajte
                                                            fotografije</label
                                                        >
                                                    </button>
                                                </div>
                                            </template>
                                        </div>
                                    </label>
                                </div>
                                <figure
                                    class="mx-auto flex w-full max-w-lg gap-3"
                                    v-if="tooLargeError"
                                >
                                    <div class="text-small-regular text-salmon">
                                        Izbrana fotografija presega največjo dovoljeno velikost.
                                        Prosimo izberite drugo fotografijo.
                                    </div>
                                </figure>
                                <figure
                                    class="mx-auto flex w-full max-w-lg gap-3"
                                    v-if="errors"
                                >
                                    <div class="text-small-regular text-salmon">
                                        Prišlo je do napake pri nalaganju, preverite da je datoteka slika.
                                    </div>
                                </figure>
                            </div>
                            <div
                                class="pictures-preview-and-actions mb-4"
                                v-if="energyPictures.length"
                            >
                                <div
                                    v-for="energyPicture in energyPictures"
                                    :key="energyPicture.name"
                                    class="flex items-center justify-between border-b py-4"
                                >
                                    <!-- <img
                                            class="preview-img"
                                            :src="
                                                energyPicture.listing_image_url
                                            "
                                        /> -->
                                    <div
                                        class="text-body-medium-button text-black-78 max-w-[45%] truncate md:max-w-full"
                                    >
                                        {{ energyPicture.name }}
                                        <!-- {{
                                                Math.round(
                                                    energyPicture.size /
                                                        1000
                                                ) + "kb"
                                            }} -->
                                    </div>
                                    <button
                                        class="button button--gray"
                                        type="button"
                                        @click="
                                            removeFile(
                                                energyPictures.indexOf(
                                                    energyPicture,
                                                    'energy_image'
                                                )
                                            )
                                        "
                                    >
                                        <v-icon icon="delete"></v-icon>
                                        <label>Odstrani</label>
                                    </button>
                                </div>
                            </div>
                          </figure>
                      </template>
                      <template v-slot:foot>
                        <a class="button button--gray" @click="removeFiles('energy_image')">
                            <v-icon icon="reload"></v-icon>
                            <label>Ponastavi</label>
                        </a>
                        <a class="button" @click="showEnergyModal = false">
                            <v-icon icon="save"></v-icon>
                            <label>Shrani</label>
                        </a>
                      </template>
                  </v-lightbox>
                </form>
              </figure>
          </figure>
      </main>
      <v-add-listing-foot>
          <a
              @click="submitForm('select-documentation-pictures')"
              class="button button--md h-[48px] w-[240px] px-6"
          >
              <label class="text-small-text-medium">Nadaljujte</label>
              <v-icon icon="arrow-right" size="4"></v-icon>
          </a>
      </v-add-listing-foot>
  </section>
</template>

<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
  components: {
      "v-add-listing-foot": AddListingFootVue,
      "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
      return {
          isDraggingTloris: false,
          isDraggingEnergy: false,
          tlorisPictures: [],
          energyPictures: [],
          showTlorisModal: false,
          showEnergyModal: false,
          errors: false,
          tooLargeError: false,
      };
  },
  mounted() {
      this.tlorisPictures = this.stepData.tloris_pictures;
      this.energyPictures = this.stepData.energy_pictures;
  },
  computed: {},
  methods: {
      openTlorisFileInput() {
        document.getElementById("tlorisFilesInput").click()
      },
      openEnergyFileInput() {
        document.getElementById("energyFilesInput").click()
      },
      submitForm(formId) {
          document.getElementById(formId).submit();
      },
      async onChangePictures(e, type) {
          e.preventDefault();

          for await (const file of type == "tloris_image"
              ? this.$refs.tlorisFilesInput.files
              : this.$refs.energyFilesInput.files) {
              var formData = new FormData();
              formData.append("file", file);
              formData.append("type", type);

              await this.uploadFile(formData, type);
          }
      },
      async uploadFile(formData, type) {
          let response = axios
              .post(this.routes.uploadFile, formData, {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "multipart/form-data",
                      "X-CSRF-TOKEN": this.$csrfToken,
                  },
              })
              .then(
                  (response) => {
                      if (type == "tloris_image") {
                          this.tlorisPictures.push(response.data);
                      } else {
                          this.energyPictures.push(response.data);
                      }
                  },
                  (error) => {
                    if (error.response.status == 413) {
                        this.tooLargeError = true;
                        setTimeout(() => { this.tooLargeError = false; }, 3000);
                    } else {
                        this.errors = error.response.data.errors;
                        setTimeout(() => { this.errors = false; }, 3000);
                    }
                  }
              );

          return response;
      },
      removeFile(fileIndex, type) {
          let picture = null;

          if (type == "tloris_image") {
              picture = this.tlorisPictures[fileIndex];
          } else {
              picture = this.energyPictures[fileIndex];
          }

          let formData = {
              file_id: picture.id,
          };

          axios.post(this.routes.deleteFile, formData, {
                  headers: {
                      "X-CSRF-TOKEN": this.$csrfToken,
                  },
              })
              .then(
                  (response) => {
                      if (type == "tloris_image") {
                          this.tlorisPictures.splice(fileIndex, 1);
                      } else {
                          this.energyPictures.splice(fileIndex, 1);
                      }
                  },
                  (error) => {
                      console.log(error);
                  }
              );
      },
      removeFiles(type) {
        let formData = {
            type: type
        };

        let extras = {
            headers: {
                "X-CSRF-TOKEN": this.$csrfToken,
            },
        }

        axios.post(this.routes.deleteFiles, formData, extras)
            .then((response) => {
                if (type == "tloris_image") {
                    this.tlorisPictures = [];
                } else {
                    this.energyPictures= []
                }
            },
            (error) => {
                console.log(error);
            });
      },
      dragoverTloris(e) {
          e.preventDefault();
          this.isDraggingTloris = true;
      },
      dragleaveTloris() {
          this.isDraggingTloris = false;
      },
      dropTlorisFile(e) {
          e.preventDefault();
          this.$refs.tlorisFilesInput.files = e.dataTransfer.files;
          this.onChangePictures(e, 'tloris_image');
          this.isDraggingTloris = false;
      },
      dragoverEnergy(e) {
          e.preventDefault();
          this.isDraggingEnergy = true;
      },
      dragleaveEnergy() {
          this.isDraggingEnergy = false;
      },
      dropEnergyFile(e) {
          e.preventDefault();
          this.$refs.energyFilesInput.files = e.dataTransfer.files;
          this.onChangePictures(e, 'energy_image');
          this.isDraggingEnergy = false;
      },
  },
};
</script>
